<div [ngbTooltip]="diffStatBlocksTooltip" [disableTooltip]="!diffStats">
  <span class="diffstats" *ngIf="diffStats"
    ><span *ngIf="diffStats.blocks"
      ><span
        class="diffstats__block diffstats__block--added"
        *ngFor="let i of diffStats.blocks.added; trackBy: trackBy"
      ></span
      ><span
        class="diffstats__block diffstats__block--deleted"
        *ngFor="let i of diffStats.blocks.deleted; trackBy: trackBy"
      ></span
      ><span
        class="diffstats__block diffstats__block--neutral"
        *ngFor="let i of diffStats.blocks.neutral; trackBy: trackBy"
      ></span></span
    >&nbsp;<span class="diff-stats__additions">{{
      diffStats.additions + diffStats.deletions | numberToHuman
    }}</span></span
  ><em *ngIf="!diffStats && displayEmptyState">none</em><!DOCTYPE html>
  <ng-template #diffStatBlocksTooltip
    >{{ diffStats.additions | numberToHuman }} additions &amp;
    {{ diffStats.deletions | numberToHuman }} deletions</ng-template
  >
</div>
